/*
/	Corentin BOUTON — Junior Mines Provence 2023
/	contact@junior-mines-provence.fr
/	https://junior-mines-provence.fr
*/

import { Navbar, Container, Button } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';

import logo from "../images/logo_StoreVision_noir.webp";

function Header({children}) {
	return <span style={{fontFamily: 'JTMarnieBold', fontSize: '140%'}}>{children}</span>;
}

function Bold({children}) {
	return (<span style={{fontFamily: 'JTMarnieBold'}}>{children}</span>)
}

function Navbar_riou() {
	const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });

	return (
		<Navbar bg="light" variant="light" sticky='top' expand='sm'>
			<Container fluid>
				<Navbar.Brand>
					<img
					alt="logo"
					src={logo}
					width="130"
					height="50"
					className="d-inline-block align-top"
					/>{' '}
					<Header>{isPortrait ? "Configurateur" : "Créez le StoreVision qui vous correspond"}</Header>
				</Navbar.Brand>

				<Button variant='outline-dark' href='https://configurateur-store-vision-pro.web.app/' target='_blank'><Bold>Version PRO 💼</Bold></Button>
			</Container>
		</Navbar>
	);
}

export default Navbar_riou;
